module.exports = __webpack_public_path__ + "static/img/cooperative_partner_5.fa037dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperative_partner_5.png
// module id = b/NZ
// module chunks = 0